<template>
    <div>
        <v-list class="px-3"  style="max-width: 270px;">
            <v-list-item>
                <v-list-item-title style="font-weight: bold;"> {{ $t('yego_dashboard.settings') }} </v-list-item-title>
            </v-list-item>
            
            <v-list-item>
                <v-list-item-title>{{ $t('yego_dashboard.show_options') }}</v-list-item-title>
            </v-list-item>
            
            <v-list-item class="my-2">
                <v-radio-group v-model="efficiency_options.result_type">
                    <v-radio class="px-1" v-for="t of efficiency_options.result_types" color="blue_accent" :key="t" :label="$t('yego_dashboard.result_types_' + t)" :value="t"></v-radio>
                </v-radio-group>
            </v-list-item>

            <v-list-item class="mt-5">
                <v-list-item-title>{{ $t('yego_dashboard.show_options') }}</v-list-item-title>
            </v-list-item>
            
            <v-list-item>
                <v-row class="px-4">
                    <v-checkbox :label="$t('yego_dashboard.delivered')" color="blue_accent" v-model="efficiency_options.deliveries" class="mx-0 my-0"></v-checkbox>
                </v-row>
            </v-list-item>

            <v-list-item>
                <v-row class="px-4">
                    <v-checkbox :label="$t('yego_dashboard.returned')" color="blue_accent" v-model="efficiency_options.returns" class="mx-0 my-0"></v-checkbox>
                </v-row>
            </v-list-item>

            <v-list-item>
                <v-row class="px-4">
                    <v-checkbox :label="$t('yego_dashboard.others')" color="blue_accent" v-model="efficiency_options.other" class="mx-0 my-0"></v-checkbox>
                </v-row>
            </v-list-item>
            

            <v-list-item>
                <v-list-item-title>{{ $t('yego_dashboard.efficiency_criterion') }}</v-list-item-title>
            </v-list-item>

            <v-list-item class="my-1">
                <v-row justify="start" align="center" class="px-5">
                    <v-col cols="1" class="py-0 my-0 px-0">
                        <v-icon color="success2" small>circle</v-icon>
                    </v-col>
                    <v-col cols="6" elevation="2" class="py-0 my-0 ml-3">
                        <v-row justify="start" align="center" class="py-0 my-0 px-0">
                            <v-col cols="5" class="py-0 my-0 px-0" style="max-height: 35px;">
                                <v-text-field solo text class="range_input" v-model="efficiency_options.green.min" ref="green_min"/>
                            </v-col>
                            <v-col cols="1" class="py-0 my-0 px-0" style="text-align: center;">-</v-col>
                            <v-col cols="5" class="py-0 my-0 px-0" style="max-height: 35px;">
                                <v-text-field solo text class="range_input" v-model="efficiency_options.green.max" ref="green_max"/>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-list-item>

            <v-list-item class="my-1">
                <v-row justify="start" align="center" class="px-5">
                    <v-col cols="1" class="py-0 my-0 px-0">
                        <v-icon color="yellow" small>circle</v-icon>
                    </v-col>
                    <v-col cols="6" elevation="2" class="py-0 my-0 ml-3">
                        <v-row justify="start" align="center" class="py-0 my-0 px-0">
                            <v-col cols="5" class="py-0 my-0 px-0" style="max-height: 30px;">
                                <v-text-field solo text class="range_input" v-model="efficiency_options.yellow.min" ref="yellow_min"/>
                            </v-col>
                            <v-col cols="1" class="py-0 my-0 px-0" style="text-align: center;">-</v-col>
                            <v-col cols="5" class="py-0 my-0 px-0" style="max-height: 30px;">
                                <v-text-field solo text class="range_input" v-model="efficiency_options.yellow.max" ref="yellow_max"/>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-list-item>

            <v-list-item class="my-1">
                <v-row justify="start" align="center" class="px-5">
                    <v-col cols="1" class="py-0 my-0 px-0">
                        <v-icon color="red" small>circle</v-icon>
                    </v-col>
                    <v-col cols="6" class="py-0 my-0 ml-3">
                        <v-row justify="start" align="center" class="py-0 my-0 px-0">
                            <v-col cols="5" class="py-0 my-0 px-0" style="max-height: 30px;">
                                <v-text-field solo text class="range_input" v-model="efficiency_options.red.min" ref="red_min"/>
                            </v-col>
                            <v-col cols="1" class="py-0 my-0 px-0" style="text-align: center;">-</v-col>
                            <v-col cols="5" class="py-0 my-0 px-0" style="max-height: 30px;">
                                <v-text-field solo text class="range_input px-0 mx-0" v-model="efficiency_options.red.max" ref="red_max"/>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
                
            </v-list-item>
            <v-list-item>
                <v-row justify="center" align="center">
                    <v-col cols="12" justify="center" align="center">
                        <v-btn color="secondary" small outlined style="min-width: 100%;" @click="emitValue()">{{ $t('yego_dashboard.update_options') }}</v-btn>
                    </v-col>
                </v-row>
            </v-list-item>
        </v-list>
    </div>
</template>

<script>

export default {
    props: [
        'efficiency_options'
    ],
    data(){
        return {}
    },
    mounted(){
    },
    methods: {
        emitValue() {
            this.$emit('efficiency_options', this.efficiency_options);
        }
    },
    watch: {}
}
</script>

<style>

</style>